<div
  class="header"
  [style.background-image]="header.featuredImage ?
  'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),url(' + header.featuredImage.url + ')'
  : ''"
  >
    <h1 class="title">{{title}}</h1>
    <h2 class="sub-title">{{header.subTitle}}</h2>
    <div class="info middle">
        <span>Analysis</span>
        <em *ngIf="date" class="vertical-line">|</em>
        <span>{{date | date: 'MMM dd, YYYY'}}</span>
        <em *ngIf="header.categoryTags.length > 0" class="vertical-line">|</em>
        <span *ngIf="header.categoryTags.length > 0">{{getCategoryTags()}}</span>
    </div>
    <div class="authors info" *ngIf="header.authors?.length > 0">
      By {{getAuthors()}}
    </div>
</div>
